import React from "react";
import {Container} from "semantic-ui-react";
import VehicleTypesList from "../../../components/torres/vehicle-type-components/vehicle-types-list";

const VehicleTypePage = () => {

    return (
        <Container style={{padding: "20px"}}>
            <VehicleTypesList/>
        </Container>
    );
};

export default VehicleTypePage;
